const SET_SYSTEM_SETTINGS = (state, obj) => {
  Object.assign(state.systemSettings, obj)

  state.systemSettings.logoUrl = obj.logo.url
  state.systemSettings.logoAuth = obj.logo_auth.url
  state.systemSettings.favicon_url = obj.favicon.url

  // button auth Wl
  state.systemSettings.btnWhiteLabel = {
    'color': `${obj.button_auth_text_color} !important`,
    'background-color': `${obj.primary_color} !important`,
    'border': `1px solid ${obj.primary_color} !important`
  }
}

export default {
  SET_SYSTEM_SETTINGS
}



// WEBPACK FOOTER //
// ./src/features/settings/store/mutations.js